export function lowercaseFirstLetter(value: string) {
  return value.length > 0 ? value.charAt(0).toLowerCase() + value.slice(1) : '';
}

export function getInteger(value?: number | string | null) {
  return value ? parseInt(String(value), 10) : 0;
}

export function validateEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const isPp = () => window.samEnv?.ENVIRONMENT?.toLowerCase() === 'pp';
export const isProd = () => window.samEnv?.ENVIRONMENT?.toLowerCase() === 'prod';
